import firebase from 'firebase/app';
import 'firebase/functions';
export async function callAPI(method, params) {
    let result = await firebase.functions().httpsCallable('httpsJoyApi')({
        jsonrpc: '2.0',
        method: method,
        params: params,
    });
    return result.data;
}
//# sourceMappingURL=JoyAPISupport.js.map